<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a><a id="page_ii"></a><a id="page_iii"></a>
<h1 class="title">The Dark Horse</h1>
<p class="subtitle">A Novel</p>
<p class="author">Rumer Godden</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?8ce1b8c4